import TEXT from './generated/TEXT/RangeSelectRow';
import { SettingRowSelect } from './SettingRowSelect';

TEXT.DEFINE({
  /** Label for the export range selection */
  range: 'Range',
});

export const RangeSelectRow = ({
  onChange,
  options,
  value,
}: {
  /** Called with the selected range value. */
  onChange: (value: string) => void;
  /** Range options as `{ value, label }` pairs. */
  options: { value: string; label: string }[];
  /** Currently selected range value. */
  value: string;
}) => {
  return (
    <SettingRowSelect
      dataTestId="range-select"
      name={TEXT.range}
      onChange={onChange}
      options={options}
      title={TEXT.range}
      value={value}
    />
  );
};
